import { translate } from '../Services/translation';

// Adds a "show more"/"show less" toggle to long category descriptions.
// The height threshold must match max-height on .category-page__intro-description--expandable.
export function ExpandableCategoryDescription() {
    const button = document.getElementById('read-more-button');
    const descriptionEle = document.querySelector(
        '.category-page__intro-description'
    );

    if (!button || !descriptionEle) {
        return;
    }

    const expandableClass = 'category-page__intro-description--expandable';
    const expandedClass = 'category-page__intro-description--expanded';

    if (descriptionEle.clientHeight > 200) {
        descriptionEle.classList.add(expandableClass);
        button.style.display = 'block';
        button.innerHTML = translate('category-navigation.show-more');

        button.addEventListener('click', function () {
            descriptionEle.classList.toggle(expandedClass);

            if (descriptionEle.classList.contains(expandedClass)) {
                button.innerHTML = translate('category-navigation.show-less');
            } else {
                button.innerHTML = translate('category-navigation.show-more');
            }
        });
    }
}
